const PLACEHOLDER_TRANSFORMATIONS = '{transformations}'
const PLACEHOLDER_MARKANT = '{MARKANT_VARIANT}'

export type IMAGE_TYPES = 'productCard' | 'shelfProductImage' | 'shelfProductImageLarge' | 'prodMarkerMap'

const transformationsMapCloudinary: Record<IMAGE_TYPES, string> = {
  'productCard': 'f_auto,q_auto,c_pad,w_200,h_200,b_transparent',
  'shelfProductImage': 'f_auto,q_auto/c_pad,w_50,h_50,b_transparent',
  'shelfProductImageLarge': 'f_auto,q_auto/c_pad,w_200,h_200,b_transparent',
  'prodMarkerMap': 'f_auto,q_auto/c_pad,w_100,h_100,b_transparent',
}

const transformationsMapMarkant: Record<IMAGE_TYPES, string> = {
  'productCard': 'thumbnail',
  'shelfProductImage': 'thumbnail',
  'shelfProductImageLarge': 'original',
  'prodMarkerMap': 'thumbnail',
}

export function transformImageUrl(src: undefined, type: IMAGE_TYPES): undefined
export function transformImageUrl(src: string, type: IMAGE_TYPES): string
export function transformImageUrl(src: string | undefined, type: IMAGE_TYPES): string | undefined
export function transformImageUrl(src: string | undefined, type: IMAGE_TYPES): string | undefined {
  if (!src) return undefined

  if (src.includes(PLACEHOLDER_MARKANT)) {
    return transformMarkantImageUrl(src, type)
  }

  return transformCloudinaryImageUrl(src, type)
}

function transformMarkantImageUrl(src: string, type: IMAGE_TYPES): string {
  const transformation = transformationsMapMarkant[type]
  return src.replace(PLACEHOLDER_MARKANT, transformation)
}

function transformCloudinaryImageUrl(src: string, type: IMAGE_TYPES): string | undefined {
  const transformation = transformationsMapCloudinary[type]
  return src.replace(PLACEHOLDER_TRANSFORMATIONS, transformation)
}